import animateScrollTo from 'animated-scroll-to'

export const scrollToTarget = async target => {
  const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0
  const targetTop = scrollY + target.getBoundingClientRect().top - offset
  const distance = targetTop - scrollY
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches

  if (!reducedMotion && Math.abs(distance) > 500) {
    await animateScrollTo(Math.max(0, targetTop + (distance > 0 ? -500 : 500)), {
      minDuration: 0,
      maxDuration: 0
    })
  }

  return animateScrollTo(targetTop, {
    minDuration: reducedMotion ? 0 : 200,
    maxDuration: reducedMotion ? 0 : 400
  })
}

const isPlainClick = event => (
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey
)

const isSamePage = url => (
  url.origin === location.origin &&
  url.pathname === location.pathname &&
  url.search === location.search
)

const hashTarget = hash => {
  try {
    return document.getElementById(decodeURIComponent(hash.slice(1)))
  } catch {
    return null
  }
}

export default function () {
  document.addEventListener('click', event => {
    if (!isPlainClick(event)) return

    const link = event.target.closest('a[href]')
    if (!link || link.matches('[download], [target]:not([target="_self"])')) return

    const url = new URL(link.href, location.href)
    if (!url.hash || !isSamePage(url)) return

    const target = hashTarget(url.hash)
    if (!target) return

    event.preventDefault()
    history.pushState(history.state, '', url.hash)
    scrollToTarget(target)
  })
}
